module.exports = __webpack_public_path__ + "img/thai_express.38825050.webp";